import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/salesSaga";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();

  let dateFormat = useDateFormat()

  let { startDate, endDate } = useSelector((state) => state.staffSales.selectedRequestDates);
  let { calendarEndDate, calendarStartDate } = useSelector((state) => state.staffSales.currentUser);

  let updateDates = (startDate, endDate) =>
    dispatch(actionCreators.updateDates({ startDate, endDate }));

  return (
    <ReactDatePicker
      showDefaultInputIcon={false}
      isRangePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      updateDates={updateDates}
    />
  );
};

export default DatePicker;
